import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useInvoice } from '../context/InvoiceContext';

const Login = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useInvoice();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const success = await login(loginId, password);
    setIsLoading(false);
    if (success) {
      navigate('/dashboard');
    }
  };

  return (
    <div className="flex-center" style={{ minHeight: '100vh', padding: 'var(--spacing-md)', backgroundColor: 'var(--color-gray-50)' }}>
      <div className="card" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-lg">
          <img
            src="/berlinr-logo.png"
            alt="BERLINR"
            style={{
              height: '80px',
              width: 'auto',
              margin: '0 auto var(--spacing-lg)',
              display: 'block'
            }}
          />
          <h2>Back Office Login</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Login ID</label>
            <input
              type="text"
              className="form-input"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              placeholder=""
              required
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder=""
                required
                disabled={isLoading}
                style={{ paddingRight: '2.5rem' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(v => !v)}
                style={{
                  position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer', padding: 0,
                  fontSize: 'var(--font-size-xs)', fontWeight: 'var(--font-weight-medium)',
                  color: 'var(--color-text-secondary)', letterSpacing: '0.04em',
                  userSelect: 'none',
                }}
                tabIndex={-1}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block btn-lg"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex-center gap-sm">
                <div className="spinner spinner-sm"></div>
                Logging in...
              </span>
            ) : (
              'Login'
            )}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 'var(--spacing-md)' }}>
          <Link to="/" className="text-secondary" style={{ fontSize: 'var(--font-size-sm)' }}>
            ← Back
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
